import React from 'react';
import SkillsTab from '../ChannelSettings/SkillsTab';

interface SkillsSelectionStepProps {
  channelId?: string;
  workspaceTag?: string;
}

const SkillsSelectionStep: React.FC<SkillsSelectionStepProps> = ({
  channelId,
  workspaceTag,
}) => {
  return (
    <SkillsTab
      key={channelId || 'no-channel'}
      channelId={channelId}
      workspaceTag={workspaceTag}
      isChannelArchived={false}
      connectSkillsWizardMode
    />
  );
};

export default SkillsSelectionStep;
